// extracted by mini-css-extract-plugin
export default {"videoPost__video":"VideoPost-module--videoPost__video--89434","videoPost__iframe":"VideoPost-module--videoPost__iframe--9557d"};